import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIParams } from './contracts/api-params.model';
import { Observable } from 'rxjs';
import { APIClient } from './contracts/api-client.service';
import { APIErrorHandler } from './contracts/api-error-handler.service';
import { catchError } from 'rxjs/operators';
import { AppSettingsService } from '../app-settings/app-settings.service';

@Injectable()
export class HspaAPIClient implements APIClient {

  constructor(private https: HttpClient,
    private appSettings: AppSettingsService,
    private errorHandler: APIErrorHandler)
    { }

  get<T>(resource: string, params: APIParams | undefined): Observable<T> {
    const url = this.formatUrl(resource);
    return this.https.get<T>(url, { params }).pipe(
      catchError((err) => this.errorHandler.handleError(err))
    );
  }

  put<T, U>(resource: string, obj: T, params?: APIParams | undefined): Observable<U> {
    const url = this.formatUrl(resource);
    return this.https.put<U>(url, obj, { params }).pipe(
      catchError((err) => this.errorHandler.handleError(err))
    );
  }

  post<T>(resource: string, obj: T, params?: APIParams | undefined,
          reportProgress?: boolean, observe?: 'body'): Observable<T> {
    const url = this.formatUrl(resource);
    return this.https.post<T>(url, obj, { observe, params, reportProgress }).pipe(
      catchError((err) => this.errorHandler.handleError(err))
    );
  }

  postText(resource: string, obj: unknown): Observable<string> {
    return this.https.post(resource, obj, { responseType: 'text' }).pipe(
      catchError((err) => this.errorHandler.handleError(err))
    );
  }

  private formatUrl(resource: string): string {
    return `${this.appSettings.apiUrl}${resource}`;;
  }

  delete<T>(resource: string, params: APIParams | undefined): Observable<T> {
    const url = this.formatUrl(resource);
    return this.https.delete<T>(url, { params }).pipe(
      catchError((err) => this.errorHandler.handleError(err))
    );
  }

  getFile(resource: string): any {
    const url = this.formatUrl(resource);

    return this.https.get(url, { responseType: 'blob' }).pipe(
      catchError((err) => this.errorHandler.handleError(err))
    );
  }
}
